(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/free-reduction/reducer.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/free-reduction/reducer.js'); "use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  var _svs$tipset$freeReduc = svs.tipset.freeReduction,
      ReduceData = _svs$tipset$freeReduc.ReduceData,
      Node = _svs$tipset$freeReduc.Node;

  var Reducer = function () {
    function Reducer(weights, reduceAmount) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, Reducer);

      if (typeof reduceAmount !== 'number') {
        throw new Error('Amount must be a number.');
      }

      this.reduceData = [];

      this._setupDataStructure(weights); 


      this.reduceAmount = reduceAmount;
      var defaultOptions = {
        randomizeEqualWeightThreshold: 0.2,
        randomizeBeginning: 65,
        weightThreshold: 0.5
      };
      this.options = _objectSpread({}, defaultOptions, {}, options);
    }

    _createClass(Reducer, [{
      key: "_setupDataStructure",
      value: function _setupDataStructure(weights) {
        var _this = this;

        this.weights = weights;
        var outcomes = ['1', 'X', '2'];

        for (var i = 0; i < this.weights.length; ++i) {
          this.reduceData.push([]);

          for (var k = 0; k < this.weights[i].length; ++k) {
            this.reduceData[i].push(new ReduceData(i + 1, outcomes[k], this.weights[i][k]));
          }
        } 


        this.sortMapping = []; 

        var sortWeights = [];
        this.weights.forEach(function (weights, index) {
          sortWeights.push({
            originalIndex: index,
            weights: weights
          });
        }); 

        sortWeights.sort(function (aW, bW) {
          var a = 0,
              b = 0;
          aW.weights.forEach(function (weight) {
            a += weight !== 0 ? 1 : 0;
          });
          bW.weights.forEach(function (weight) {
            b += weight !== 0 ? 1 : 0;
          });

          if (a === b) {
            a = 0;
            b = 0;
            aW.weights.forEach(function (weight) {
              a += weight !== 0 ? 1 : 0;
            });
            bW.weights.forEach(function (weight) {
              b += weight !== 0 ? 1 : 0;
            });
            a = 100 / a;
            b = 100 / b;
            var aE = aW.weights.reduce(function (acc, weight) {
              return Math.abs(a - weight) > acc && weight !== 0 ? Math.abs(a - weight) : acc;
            }, 0);
            var bE = bW.weights.reduce(function (acc, weight) {
              return Math.abs(b - weight) > acc && weight !== 0 ? Math.abs(b - weight) : acc;
            }, 0); 

            return aE === bE ? 0 : aE > bE ? -1 : 1;
          } 


          return a > b ? 1 : -1;
        }); 

        sortWeights.forEach(function (_ref) {
          var originalIndex = _ref.originalIndex;

          _this.sortMapping.push(originalIndex);
        });
      }
    }, {
      key: "_buildTree",
      value: function _buildTree() {
        this.tree = new Node();
        var children = [this.tree],
            newChildren = [];

        for (var i = 0; i < this.weights.length; ++i) {
          for (var l = 0; l < children.length; ++l) {
            for (var k = 0; k < this.weights[i].length; ++k) {
              if (this.weights[this.sortMapping[i]][k] === 0) {
                continue;
              }

              var node = new Node(children[l], this.reduceData[this.sortMapping[i]][k]);
              newChildren.push(node);
              children[l].children.push(node);
            }
          }

          children = newChildren;
          newChildren = [];
        }
      }
    }, {
      key: "reduce",
      value: function reduce() {
        var reducedRows = [],
            onlyOutcomeRows = [];

        this._buildTree();

        this.currentAmountOfReducedRows = 0;

        for (var i = 0; i < this.reduceAmount; ++i) {
          var uniqueRow = this._getUniqueRow(this.tree);

          if (uniqueRow.length === 0) {
            break;
          }

          this._maybeRemoveNode(uniqueRow[uniqueRow.length - 1]);

          this.currentAmountOfReducedRows += 1;
          reducedRows.push(uniqueRow);
        }

        for (var _i = 0; _i < reducedRows.length; ++_i) {
          onlyOutcomeRows[_i] = [];

          for (var k = 0; k < reducedRows[_i].length; ++k) {
            onlyOutcomeRows[_i][this.sortMapping[k]] = reducedRows[_i][k].data.outcome;
          }
        }

        return onlyOutcomeRows;
      }

    }, {
      key: "_getUniqueRow",
      value: function _getUniqueRow(node) {
        var _this2 = this;

        var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        if (node.children.length === 0) {
          return row;
        }

        var selectedChild;

        if (this._getAmountOfRows() >= this.options.randomizeBeginning) {
          var useNeedy = false;
          node.children.forEach(function (child) {
            if (child.data.getDistanceFromTargetWeight() >= _this2.options.weightThreshold) {
              useNeedy = true;
            }
          });

          if (useNeedy) {
            selectedChild = node.getMostNeedyChild(this.options);
          } else {
            selectedChild = node.getRandomWeightedChild();
          }
        } else {
          selectedChild = node.getRandomWeightedChild();
        }

        selectedChild.data.picks += 1;
        selectedChild.calculateNewActual();
        row.push(selectedChild);
        return this._getUniqueRow(selectedChild, row);
      }
    }, {
      key: "_maybeRemoveNode",
      value: function _maybeRemoveNode(node) {
        if (!node.parent) {
          return; 
        }

        for (var i = 0; i < node.parent.children.length; ++i) {
          if (node.parent.children[i].data.outcome === node.data.outcome) {
            node.parent.children.splice(i, 1);
          }
        }

        var hasWorthyChildren = false;

        for (var _i2 = 0; _i2 < node.parent.children.length; ++_i2) {
          if (node.parent.children[_i2].data.weight > 0) {
            hasWorthyChildren = true;
          }
        }

        if (!hasWorthyChildren && node.parent) {
          this._maybeRemoveNode(node.parent);
        }
      } 

    }, {
      key: "_getAmountOfRows",
      value: function _getAmountOfRows() {
        return this.currentAmountOfReducedRows / this.reduceAmount * 100;
      }
    }]);

    return Reducer;
  }();

  svs.tipset.freeReduction.Reducer = Reducer;
})(svs);
 })(window);